import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import CFormat from "currency-formatter"
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import {AiFillCloseCircle} from "react-icons/ai"

import NavBar from "../../Components/NavBar/NavBar"
import Footer from "../../Components/Footer/Footer"
import { CarsSliderHorizontal } from "../Home/Components/CarSlider/CarsSlider"

import WhiteCar from "../../Assets/card1.png"
import BlackCar from "../../Assets/blackCar.png"
import GrayCar from "../../Assets/grayCar.png"
import BlueCar from "../../Assets/blueCar.png"
import RedCar from "../../Assets/redCar.png"

import White from "../../Assets/white.avif"
import Gray from "../../Assets/gray.avif"
import Blue from "../../Assets/blue.avif"
import Black from "../../Assets/black.avif"
import Red from "../../Assets/red.avif"
import WhiteWheel from "../../Assets/whiteWheel.avif"
import BlackWheel from "../../Assets/blackWheel.avif"

import { useSelector } from 'react-redux';

import "./CarDesign.scss"


const CarsDataDemo = {
    red: { img: RedCar },
    white: { img: WhiteCar },
    blue: { img: BlueCar },
    gray: { img: GrayCar },
    black: { img: BlackCar },
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "70%",
    // bgcolor: '#DDC861',
    // backgroundColor:"red",
    // border: '10px solid #DDC861',
    borderRadius: "10px",
    // boxShadow: 24,
    overflow: "hidden"
    // p: 4,
};

const paymentStyle = {
    position: 'absolute',
    top: '1%',
    left: '2%',
    bottom: "1%",
    right: "2%",
    bgcolor: 'transparent',
    border: 'none',
    overFlowY: "scroll",
    p: 1,
};



const CarDesign = () => {
    let location = useLocation()
    let id = new URLSearchParams(location.search).get("id")

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    let CarsData = useSelector((state) => state.CarsData)

    const [currentCar, setCurrentCar] = useState(null)

    const [totalPrice, setTotalPrice] = useState(0)

    const [selectedPower, setSelectedPower] = useState(null)

    const [allPaints, SetAllPaints] = useState(null)
    const [selectedPaint, setSelectedPaint] = useState(null)

    const [allWheels, setAllWheels] = useState(null)
    const [selectedWheel, setSelectedWheel] = useState(null)

    const [allInterior, setAllInterior] = useState(null)
    const [selectedInterior, setSelectedInterior] = useState(null)

    const [charging1, setCharging1] = useState(false)
    const [charging2, setCharging2] = useState(false)

    // const [open, setOpen] = React.useState(id ? false : true);
    // const [selectedCar, setSelectedCar] = useState("white")

    const changePower = (data) => {
        setSelectedPower(data)
    }
    const changeColor = (data) => {
        setSelectedPaint(data)
    }
    const changeWheel = (data) => {
        setSelectedWheel(data)
    }
    const changeInterior = (data) => {
        setSelectedInterior(data)
    }
    const changeCharging = (data) => {
        if (data == "1") {
            setCharging1(!charging1)
        } else {
            setCharging2(!charging2)
        }
    }

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };
    // const handleClose = () => {
    //     setOpen(false);
    // };


    useEffect(() => {
        if (CarsData && CarsData.length >= 1) {
            let findCar = CarsData.find((e) => e._id == id)
            setCurrentCar(findCar)

            setSelectedPower(findCar.price)

            SetAllPaints(findCar.paintsWheels)
            setSelectedPaint(findCar.paintsWheels[0])

            setAllWheels(findCar.paintsWheels[0].wheels)
            setSelectedWheel(findCar.paintsWheels[0].wheels[0])

            setAllInterior(findCar.interior)
            setSelectedInterior(findCar.interior[0])
        }
    }, [CarsData, location])
    useEffect(() => {
        if (selectedPaint) {
            setAllWheels(selectedPaint.wheels)
            setSelectedWheel(selectedPaint.wheels[0])
        }
    }, [selectedPaint])

    useEffect(() => {
        if (currentCar) {
            let price = 0
            if (selectedPower) {
                price += Number(selectedPower)
            }
            if (selectedPaint) {
                price += Number(selectedPaint.price)
            }
            if (selectedWheel) {
                price += Number(selectedWheel.price)
            }
            if (selectedInterior) {
                price += Number(selectedInterior.price)
            }
            if (charging1) {
                price += Number(currentCar.chargingPrice1)
            }
            if (charging2) {
                price += Number(currentCar.chargingPrice2)
            }

            setTotalPrice(price)
        }
    }, [currentCar, selectedPower, selectedPaint, selectedWheel, selectedInterior, charging1, charging2])

    useEffect(() => {
        window.scrollTo(0, 0);

    }, [])

    console.log(selectedInterior)

    return (
        <>
            <NavBar />
            {/* <Modal
                open={open}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Box sx={style}>
                    <CarsSliderHorizontal />
                </Box>
            </Modal> */}
            {
                selectedPaint && selectedWheel && selectedInterior &&
                <div className="cardesign_container">
                    <div className="cardesign_box">
                        <div className="img_box">
                            <img src={selectedWheel.carImg} alt="" />
                        </div>
                        <div className="options_box" style={id ? {} : { filter: "blur(4px)" }}>
                            <div className="name">
                                {currentCar.name}
                            </div>
                            <div className="delivery">
                                Est. Delivery: Oct - Dec 2022
                            </div>
                            <div className="price_box">
                                <div className="purchases potential">
                                    Purchase Price
                                </div>
                                {/* <div className="potential">
                                    Potential Price
                                </div> */}
                            </div>
                            <div className="performance_box">
                                <div className="range">
                                    <div className="value">{currentCar.milage}<span>mi</span></div>
                                    <div className="dec">Range(est.)</div>
                                </div>
                                <div className="range">
                                    <div className="value">{currentCar.power}<span>mph</span></div>
                                    <div className="dec">Range(est.)</div>
                                </div>
                                <div className="range">
                                    <div className="value">{currentCar.pickup}<span>sec</span></div>
                                    <div className="dec">Range(est.)</div>
                                </div>
                            </div>
                            <div className="drive_box">
                                <div className="title">Rear-Wheel Drive</div>
                                <div className="detail_box" style={selectedPower == currentCar.price ? { border: "1px solid #DDC861" } : {}} onClick={() => changePower(currentCar.price)}>
                                    <div className="dec">{currentCar.name}</div>
                                    <div className="price">{CFormat.format(currentCar.price, { code: "USD" })}</div>
                                </div>
                                {/* <span>Learn more about Range and Performance</span> */}
                            </div>
                            <div className="drive_box">
                                <div className="title">Dual Motor All-Wheel Drive</div>
                                <div className="detail_box" style={selectedPower == currentCar.upgradePrice ? { border: "1px solid #DDC861" } : {}} onClick={() => changePower(currentCar.upgradePrice)}>
                                    <div className="dec">{currentCar.upgradeName}</div>
                                    <div className="price">{CFormat.format(currentCar.upgradePrice, { code: "USD" })}</div>
                                </div>
                            </div>
                            {/* <div className="note">
                                * Prices above include potential incentives and gas savings of $6,600. Learn More
                            </div> */}
                            {/* <div className="feature">Feature Details</div> */}
                            <br />
                            <br />
                            <br />
                            <div className="paint_box">
                                <div className="title">Paint</div>
                                <div className="paints">
                                    {
                                        allPaints.map((data) => {
                                            return (
                                                <div className="paint" style={{ border: selectedPaint.title == data.title ? "2px solid #DDC861" : null }} onClick={() => changeColor(data)}><img src={data.img} alt="" /></div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="dec">{selectedPaint.title}t <span>{selectedPaint.price == "0" ? "Include" : CFormat.format(selectedPaint.price, { code: "USD" })}</span></div>
                            </div>
                            <br />
                            <br />
                            <br />
                            <div className="wheel_box">
                                <div className="title">Wheels</div>
                                <div className="wheels">
                                    {
                                        allWheels.map((data) => {
                                            return (
                                                <div className="wheel" style={{ border: selectedWheel.title == data.title ? "2px solid #DDC861" : null }} onClick={() => changeWheel(data)}><img src={data.img} alt="" /></div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="dec">{selectedWheel.title} <span>{selectedWheel.price == "0" ? "Include" : CFormat.format(selectedWheel.price, { code: "USD" })}</span>
                                    <br />
                                    {/* <span style={{ fontSize: ".8rem", textAlign: "center", display: "flex", justifyContent: "center" }}>Range (EPA est.) : 272mi</span> */}
                                </div>
                            </div>
                            <br />
                            <br />
                            <br />
                            <div className="interior_box">
                                <div className="title">Interior</div>
                                <div className="interiors">
                                    {
                                        allInterior.map((data) => {
                                            return (
                                                <div className="interior" style={{ border: selectedInterior.title == data.title ? "2px solid #DDC861" : null }} onClick={() => changeInterior(data)}><img src={data.paintImg} alt="" /></div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="dec">{selectedInterior.title} <span>{selectedInterior.price == "0" ? "Include" : CFormat.format(selectedInterior.price, { code: "USD" })}</span></div>
                                {/* <div className="feature">Feature Details</div> */}
                            </div>
                            <br />
                            <br />
                            <br />
                            <div className="charging_box">
                                <div className="title">Charging</div>
                                <div className="chargings">
                                    <FormControlLabel control={<Checkbox checked={charging1} onClick={() => changeCharging("1")} sx={{ '& .MuiSvgIcon-root': { fontSize: 30, color: "#DDC861" } }} />} label={<> <div className="charging"> <span> {currentCar.chargingName1} </span> <span className='price'>{CFormat.format(currentCar.chargingPrice1, { code: "USD" })}</span> </div> </>} />
                                    <FormControlLabel control={<Checkbox checked={charging2} onClick={() => changeCharging("2")} sx={{ '& .MuiSvgIcon-root': { fontSize: 30, color: "#DDC861" } }} />} label={<> <div className="charging"> <span> {currentCar.chargingName2} </span> <span className='price'>{CFormat.format(currentCar.chargingPrice2, { code: "USD" })}</span> </div> </>} />
                                </div>
                                {/* <div className="feature">Learn More</div> */}
                            </div>
                            <br />
                            <br />
                            <br />
                            <div className="payment_box">
                                <div className="title">Order Your {currentCar.name} </div>
                                <div className="detail">Total Price : <span style={{ color: "#DDC861" }}> {CFormat.format(totalPrice, { code: "USD" })} </span> </div>
                                <div className="detail">Est. Delivery: Dec 2022 - Apr 2023</div>
                                <div className="payment" onClick={handleOpen}>Continue to Payment</div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal_container" sx={paymentStyle}>
                    <div className="close_icon" onClick={handleClose}>
                        <AiFillCloseCircle />
                    </div>
                    <div className="paypal_container">
                        <PayPalScriptProvider textAlign='center'>
                            <PayPalButtons
                                options={{
                                    "client-id": "paypal url should be here",
                                    components: "buttons",
                                    currency: "USD"
                                }}
                                style={{ "layout": "vertical" }}
                                disabled={false}
                                forceReRender={["77", "USD", { "layout": "vertical" }]}
                                fundingSource={undefined}
                                createOrder={(data, actions) => {
                                    return actions.order
                                        .create({
                                            purchase_units: [
                                                {
                                                    amount: {
                                                        currency_code: "USD",
                                                        value: "65",
                                                    },
                                                },
                                            ],
                                        })
                                        .then((orderId) => {
                                            // Your code here after create the order
                                            return orderId;
                                        });
                                }}
                                onApprove={function (data, actions) {
                                    return actions.order.capture().then(function () {
                                        // PaymentSuccess()

                                        alert("Success")
                                    });
                                }}
                                onCancel={() => {
                                    alert("Cancle")
                                    // canclePayment()
                                }}
                            />
                        </PayPalScriptProvider>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default CarDesign